import Web3 from "web3";
import React, { useEffect, useState } from "react";

import { FiSearch } from "react-icons/fi";
import { CgProfile } from "react-icons/cg";
import { GiBallPyramid, GiBattery100 } from "react-icons/gi";
import { HiOutlineClipboardCheck, HiOutlineClock } from "react-icons/hi";
import { SiClockify, SiOpenaccess } from "react-icons/si";
import {
    MdModelTraining,
    MdOutlineFreeCancellation,
    MdOutlineGeneratingTokens,
    MdOutlineNotStarted,
    MdOutlineVerifiedUser,
} from "react-icons/md";
import CollapsableSelect from "../../UI/CollapsableSelect";
import { FaHourglassEnd, FaRegStopCircle } from "react-icons/fa";
import {
    BsBatteryFull,
    BsBatteryHalf,
    BsEmojiSunglasses,
} from "react-icons/bs";
import { AiTwotoneExperiment } from "react-icons/ai";

import LaunchPadCard from "./LaunchPadCard";
import LoadingBar from "../../../Components/UI/LoadingBar";
import { ReactComponent as VerifiedBadge } from "../../../assets/images/launchpad/verified-badge.svg";

import {
    useRpcURL,
    useStorageContractAddress,
    useValidAccount,
} from "../../../hooks";

import {
    PRESALE_UPCOMING,
    PRESALE_INPROGRESS,
    PRESALE_FILLED,
    PRESALE_ENDED,
    PRESALE_CANCELED,
    PRESALE_ENDED_NOT_MET_SOFTCAP,
    PRESALE_FINALISED,
    REMOVED_PRESALES,
} from "../../../utils/constants";

import {
    getPresaleDetails,
    likePresale,
    // setPresaleDetails,
} from "../../../utils/apis";

import ABI_StorageLaunchpad from "../../../abis/ABI_StorageLaunchpad.json";
import PresaleABI from "../../../abis/ABI_Presale.json";

// import { abi as ABI_ERC20 } from "../../../abis/ERC20.json";
import { TbMusic, TbTractor } from "react-icons/tb";
import LinkWithSearchParams from "../../UI/LinkWithSearchParams";
const LaunchPadDashboard = () => {
    const STORAGE_CONTRACT_ADDRESS = useStorageContractAddress();
    const HTTP_RPC_URL = useRpcURL();

    const { account } = useValidAccount();

    const [launchPadArray, setLaunchPadArray] = useState([]);
    const [mainLoading, setMainLoading] = useState(true);

    const [sortValue, setSortValue] = useState("");
    const [filterValue, setFilterValue] = useState("");
    const [, /*tagValue*/ setTagValue] = useState("");
    const [, /*categoryValue*/ setCategoryValue] = useState("");

    const sortHandler = (value) => {
        setSortValue(value);
    };
    const filterHandler = (value) => {
        setFilterValue(value);
    };
    const tagHandler = (value) => {
        setTagValue(value);
    };
    const categoryHandler = (value) => {
        setCategoryValue(value);
    };

    const likeHandler = async (presaleAddress) => {
        // console.log(presaleAddress, account);
        const offChainData = await likePresale(presaleAddress, account);
        const updatedLauchpadArray = launchPadArray.map((item) => {
            if (
                item.presaleAddress.toLowerCase() !==
                presaleAddress.toLowerCase()
            )
                return item;
            else {
                item.offChainData = offChainData;
                return item;
            }
        });
        setLaunchPadArray(updatedLauchpadArray);
    };

    const adjustedArray = () => {
        if (launchPadArray.length === 0) return [];
        let resultArr = launchPadArray.filter(
            (item) => !REMOVED_PRESALES.includes(item.presaleAddress)
        );
        switch (sortValue) {
            case "HardCap":
                resultArr = resultArr.sort((a, b) => b.hardCap - a.hardCap);
                break;
            case "SoftCap":
                resultArr = resultArr.sort((a, b) => b.hardCap - a.hardCap);
                break;
            case "LP percent":
                resultArr = resultArr.sort((a, b) => b.liquidity - a.liquidity);
                break;
            case "Start time":
                resultArr = resultArr.sort(
                    (a, b) => b.presaleStartTime - a.presaleStartTime
                );
                break;
            case "End time":
                resultArr = resultArr.sort(
                    (a, b) => b.presaleEndTime - a.presaleEndTime
                );
                break;
            default:
                break;
        }
        switch (filterValue) {
            case "All":
            case "KYC Verified":
                break;
            case "Upcoming":
                resultArr = resultArr.filter(
                    (item) => item.status === PRESALE_UPCOMING
                );
                break;
            case "In Progress":
                resultArr = resultArr.filter(
                    (item) => item.status === PRESALE_INPROGRESS
                );
                break;
            case "Filled":
                resultArr = resultArr.filter(
                    (item) => item.status === PRESALE_FILLED
                );
                break;
            case "Ended":
                resultArr = resultArr.filter(
                    (item) => item.status === PRESALE_ENDED
                );
                break;
            case "Cancelled":
                resultArr = resultArr.filter(
                    (item) =>
                        item.status === PRESALE_ENDED_NOT_MET_SOFTCAP ||
                        item.status === PRESALE_CANCELED
                );
                break;
            default:
                break;
        }
        return resultArr;
    };
    useEffect(() => {
        const provider = new Web3(
            new Web3.providers.HttpProvider(HTTP_RPC_URL)
        );
        window.web3 = new Web3(provider);
        if (HTTP_RPC_URL) loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [HTTP_RPC_URL]);

    const loadData = async () => {
        const web3 = window.web3;
        const _storageContract = new web3.eth.Contract(
            ABI_StorageLaunchpad,
            STORAGE_CONTRACT_ADDRESS
        );

        const _totalProjects = await _storageContract.methods
            .getProjectsCount()
            .call();
        if (parseInt(_totalProjects) === 0) setMainLoading(false);
        const _0toNarr = Array.from(
            { length: _totalProjects },
            (_, index) => index
        );
        const presaleAddresses = await Promise.all(
            _0toNarr.map((index) =>
                _storageContract.methods.entryListByPresaleAddress(index).call()
            )
        );
        const presaleContracts = presaleAddresses.map(
            (address) => new web3.eth.Contract(PresaleABI, address)
        );
        const [
            // tokenAddressArr,
            tokenNameArr,
            tokenHardCapArr,
            presaleStateArr,
            finalizedArr,
            contributionArr,
            MincontributionArr,
            MaxcontributionArr,
            tokenLockTimeArr,
            preSaleStartTimeArr,
            preSaleEndTimeArr,
            liqudityArr,
            progressArr,
        ] = await Promise.all([
            // Promise.all(
            //     presaleContracts.map((_presaleContract) =>
            //         _presaleContract.methods.token().call()
            //     )
            // ),
            Promise.all(
                presaleContracts.map((_presaleContract) =>
                    _presaleContract.methods.tokenName().call()
                )
            ),
            Promise.all(
                presaleContracts.map((_presaleContract) =>
                    _presaleContract.methods.tokenHardCap().call()
                )
            ),
            Promise.all(
                presaleContracts.map((_presaleContract) =>
                    _presaleContract.methods.presaleState().call()
                )
            ),
            Promise.all(
                presaleContracts.map((_presaleContract) =>
                    _presaleContract.methods.finalized().call()
                )
            ),
            Promise.all(
                presaleContracts.map((_presaleContract) =>
                    _presaleContract.methods.getContribution(account).call()
                )
            ),
            Promise.all(
                presaleContracts.map((_presaleContract) =>
                    _presaleContract.methods.tokenMinContribution().call()
                )
            ),
            Promise.all(
                presaleContracts.map((_presaleContract) =>
                    _presaleContract.methods.tokenMaxContribution().call()
                )
            ),
            Promise.all(
                presaleContracts.map((_presaleContract) =>
                    _presaleContract.methods.tokenLockTime().call()
                )
            ),
            Promise.all(
                presaleContracts.map((_presaleContract) =>
                    _presaleContract.methods.tokenStartTime().call()
                )
            ),
            Promise.all(
                presaleContracts.map((_presaleContract) =>
                    _presaleContract.methods.tokenEndTime().call()
                )
            ),
            Promise.all(
                presaleContracts.map((_presaleContract) =>
                    _presaleContract.methods.tokenDEXLiquidity().call()
                )
            ),
            Promise.all(
                presaleContracts.map((_presaleContract) =>
                    _presaleContract.methods.weiRaised().call()
                )
            ),
        ]);
        presaleStateArr.forEach(
            (item, index) => (presaleStateArr[index] = parseInt(item))
        );

        const [offChainDataArr, projectStoreArr] = await Promise.all([
            Promise.all(
                presaleAddresses.map((address) => getPresaleDetails(address))
            ),
            Promise.all(
                presaleAddresses.map((address) =>
                    _storageContract.methods.ProjectStoreByOwner(address).call()
                )
            ),
        ]);

        // console.log(tokenAddressArr);

        // const tokenContracts = tokenAddressArr.map(
        //     (address) => new web3.eth.Contract(ABI_ERC20, address)
        // );

        // const owners = await Promise.all(
        //     tokenContracts.map((tokenContract) =>
        //         tokenContract.methods.owner().call()
        //     )
        // );

        // owners.forEach((owner, index) => {
        //     setPresaleDetails(presaleAddresses[index], {
        //         tokenOwner: owners[index],
        //     });
        // });

        let _array = [];

        _0toNarr.forEach((index) => {
            let _item = {
                index,
                cardId: index,
                offChainData: offChainDataArr[index],
                presaleAddress: presaleAddresses[index],
                audit: "",
                name: tokenNameArr[index],
                presaleState: presaleStateArr[index],
                finalized: finalizedArr[index],
                con: contributionArr[index],
                minCon: window.web3.utils.fromWei(
                    MincontributionArr[index].toString(),
                    "ether"
                ),
                maxCon: window.web3.utils.fromWei(
                    MaxcontributionArr[index].toString(),
                    "ether"
                ),
                softCap: tokenHardCapArr[index] / 2,
                hardCap: tokenHardCapArr[index],
                progress: window.web3.utils.fromWei(
                    progressArr[index].toString(),
                    "ether"
                ),
                liquidity: liqudityArr[index],
                lockupTime: tokenLockTimeArr[index],
                presaleStartTime: parseInt(preSaleStartTimeArr[index]),
                presaleEndTime: parseInt(preSaleEndTimeArr[index]),
                projectStore: projectStoreArr[index],
            };
            const currentTime = parseInt(new Date().getTime() / 1000);
            if (_item.finalized === true) {
                _item.status = PRESALE_FINALISED;
            } else if (_item.progress >= _item.hardCap - _item.minCon)
                _item.status = PRESALE_FILLED;
            else if (currentTime < _item.presaleStartTime)
                _item.status = PRESALE_UPCOMING;
            else if (currentTime < _item.presaleEndTime) {
                if (_item.presaleState === 0) _item.status = PRESALE_CANCELED;
                else {
                    // _item.status = PRESALE_ENDED;
                    _item.status = PRESALE_INPROGRESS;
                }
            } else {
                //time ended
                if (_item.progress < _item.softCap)
                    _item.status = PRESALE_ENDED_NOT_MET_SOFTCAP;
                else if (_item.presaleState === 0) {
                    _item.status = PRESALE_CANCELED;
                } else _item.status = PRESALE_ENDED;
            }

            _array.push(_item);
        });
        setMainLoading(false);
        setLaunchPadArray(
            _array.sort((a, b) => b.presaleStartTime - a.presaleStartTime)
        );
    };

    const sortSelectProps = {
        name: "sortHandler",
        select: [
            {
                icon: (
                    <div className="p-2 flex justify-center rounded-full bg-kadDarkBg">
                        <BsBatteryFull className="size-1" />
                    </div>
                ),
                text: "HardCap",
            },
            {
                icon: (
                    <div className="p-2 flex justify-center rounded-full bg-kadDarkBg">
                        <BsBatteryHalf className="size-1" />
                    </div>
                ),
                text: "SoftCap",
            },
            {
                icon: (
                    <div className="p-2 flex justify-center rounded-full bg-kadDarkBg">
                        <AiTwotoneExperiment className="size-1" />
                    </div>
                ),
                text: "LP percent",
            },
            {
                icon: (
                    <div className="p-2 flex justify-center rounded-full bg-kadDarkBg">
                        <MdOutlineNotStarted className="size-1" />
                    </div>
                ),
                text: "Start time",
            },
            {
                icon: (
                    <div className="p-2 flex justify-center rounded-full bg-kadDarkBg">
                        <FaRegStopCircle className="size-1" />
                    </div>
                ),
                text: "End time",
            },
        ],
        initialValue: "Sort by",
        handler: sortHandler,
    };
    const filterSelectProps = {
        name: "filterHandler",
        select: [
            {
                icon: (
                    <div className="p-2 flex justify-center rounded-full bg-kadDarkBg">
                        <GiBallPyramid className="size-1" />
                    </div>
                ),
                text: "All",
            },
            {
                icon: (
                    <div className="p-2 flex justify-center rounded-full bg-kadDarkBg">
                        <HiOutlineClock className="size-1" />
                    </div>
                ),
                text: "Upcoming",
            },
            {
                icon: (
                    <div className="p-2 flex justify-center rounded-full bg-kadDarkBg">
                        <SiClockify className="size-1" />
                    </div>
                ),
                text: "In Progress",
            },
            {
                icon: (
                    <div className="p-2 flex justify-center rounded-full bg-kadDarkBg">
                        <GiBattery100 className="size-1" />
                    </div>
                ),
                text: "Filled",
            },
            {
                icon: (
                    <div className="p-2.5 flex justify-center rounded-full bg-kadDarkBg">
                        <FaHourglassEnd className="size-base" />
                    </div>
                ),
                text: "Ended",
            },
            {
                icon: (
                    <div className="p-2 flex justify-center rounded-full bg-kadDarkBg">
                        <MdOutlineFreeCancellation className="size-1" />
                    </div>
                ),
                text: "Cancelled",
            },
        ],
        initialValue: "Status",
        handler: filterHandler,
    };

    const tagFilterSelectProps = {
        name: "tagFilter",
        select: [
            {
                icon: (
                    <div className="p-2 flex justify-center rounded-full bg-kadDarkBg">
                        <CgProfile className="size-1" />
                    </div>
                ),
                badge: <VerifiedBadge className="ml-1" />,
                text: "KYC Verified",
            },
            {
                icon: (
                    <div className="p-2 flex justify-center rounded-full bg-kadDarkBg">
                        <MdOutlineVerifiedUser className="size-1" />
                    </div>
                ),
                badge: <VerifiedBadge className="ml-1" />,
                text: "Audit Verified",
            },
            {
                icon: (
                    <div className="p-2 flex justify-center rounded-full bg-kadDarkBg">
                        <HiOutlineClipboardCheck className="size-1" />
                    </div>
                ),
                text: "Whitelisted IDO",
            },
            {
                icon: (
                    <div className="p-2 flex justify-center rounded-full bg-kadDarkBg">
                        <SiOpenaccess className="size-1" />
                    </div>
                ),
                text: "Open to all",
            },
        ],
        initialValue: "Tags",
        handler: tagHandler,
    };
    const categoryFilterSelectProps = {
        name: "categoryFilter",
        select: [
            {
                icon: (
                    <div className="p-2 flex justify-center rounded-full bg-kadDarkBg">
                        <TbTractor className="size-1" />
                    </div>
                ),
                text: "Farms",
            },
            {
                icon: (
                    <div className="p-2 flex justify-center rounded-full bg-kadDarkBg">
                        <BsEmojiSunglasses className="size-1" />
                    </div>
                ),
                text: "Meme",
            },
            {
                icon: (
                    <div className="p-2 flex justify-center rounded-full bg-kadDarkBg">
                        <TbMusic className="size-1" />
                    </div>
                ),
                text: "Utility",
            },
            {
                icon: (
                    <div className="p-2 flex justify-center rounded-full bg-kadDarkBg">
                        <MdOutlineGeneratingTokens className="size-1" />
                    </div>
                ),
                text: "NFT",
            },
            {
                icon: (
                    <div className="p-2 flex justify-center rounded-full bg-kadDarkBg">
                        <MdModelTraining className="size-1" />
                    </div>
                ),
                text: "Standard",
            },
        ],
        initialValue: "Categories",
        handler: categoryHandler,
    };
    return (
        <div className="flex flex-col main-container animation-fade-in relative">
            <h2 className="page-title">Launchpad Dashboard</h2>
            <h5 className="page-subtitle">Explore New Ideas</h5>
            <div className="relative flex items-center">
                <FiSearch className="absolute left-4" size={20} />
                <input
                    type="text"
                    className="rounded-lg text-[14px] p-3 pl-12 w-full"
                    placeholder="Search Projects..."
                />
                <LinkWithSearchParams
                    to={{
                        pathname: "/create-launchpad",
                    }}
                    className="blueGradient-button absolute right-1 p-2 rounded-md size-base font-semibold"
                >
                    Create Launchpad
                </LinkWithSearchParams>
            </div>
            <div className="flex flex-col md:flex-row py-6 justify-center gap-x-8">
                {mainLoading ? (
                    <LoadingBar />
                ) : launchPadArray.length === 0 ? (
                    <span className="size-4 mx-auto font-bold tracking-wider text-purple dark:text-yellow">
                        Nothing To Show
                    </span>
                ) : (
                    <>
                        <div className="flex flex-col w-full md:w-96 gap-4 pb-4">
                            <CollapsableSelect {...sortSelectProps} />
                            <CollapsableSelect {...filterSelectProps} />
                            <CollapsableSelect {...tagFilterSelectProps} />
                            <CollapsableSelect {...categoryFilterSelectProps} />
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full gap-x-8 gap-y-8 2xl:gap-x-8 2xl:gap-y-12">
                            {adjustedArray().map((el, i) => (
                                <LaunchPadCard
                                    likeHandler={likeHandler}
                                    key={i}
                                    {...el}
                                />
                            ))}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};
export default LaunchPadDashboard;
